<template>
  <div class="mynews">
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="我的消息" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content">
      <van-tabs v-if="classifyDatas != ''"  v-model="active" :swipe-threshold="classifyDatas.length" @click="vantabPlay">
        <van-tab v-for="index in classifyDatas.length" :title="classifyDatas[index-1].name" :key="index">
          <!--<div slot="title">{{ index == 1? '交易物流' : index == 2? '通知' : index == 3? '互动' : ''}}</div>-->
        </van-tab>
      </van-tabs>
      <div class="nodata text-cent" v-if="finished && datas == ''">
        <P class="imgbox">
          <img src="/static/images/nodataimg5.png"/>
        </P>
        <p class="text">还没有相关消息~</p>
      </div>
      <div class="newslist">
        <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="-1">
          <van-cell-group v-for="(items,index) in datas" :key="items.id">
            <div class="van-cell">
              <router-link tag="div" :to="{path:items.order_id != null?'/user/myorder/order':'/user/mynews/news',query:{id:items.order_id != null?items.order_id:items.id}}" class="newsbox">
                <div>{{ items.title }}<span class="float-right">{{ items.add_time }}</span></div>
                <div class="van-card" :class="{'noimg':items.pic_url == ''}">
                  <div class="van-card__thumb newsimgbox" v-if="items.pic_url != ''">
                    <img onerror="src='/static/errorimg1.png'" :src="items.pic_url" class="newsimg">
                  </div>
                  <div class="van-card__content news-content">
                    <div class="ellipseal">{{ items.content }}</div>
                  </div>
                </div>
                <i class="van-icon van-icon-arrow"></i>
              </router-link>
            </div>
          </van-cell-group>
          <div v-if="!loading && finished && datas != ''" class="nomore"><span>已经到底了</span></div>
        </van-list>
      </div>
      <!--<keep-alive>
        <router-view></router-view>
      </keep-alive>-->
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "mynews",
    components: {
      TopNav
    },
    data () {
      return {
        datas:[],
        classifyDatas:'',
        page:0,
        active:this.$route.query.type,
        finished:false,
        loading:true,
      }
    },
    methods: {
      goBack: function () {
        this.$router.push({ name: 'User' })
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      routerPlay: function (index) {
        this.datas = []
        this.page = 0
        if(this.finished){
          this.finished = false
        }else{
          this.loading = true
          this.getDatas()
        }
      },
      getClassify:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Message/Index/message_classify', {p:this.page}, res => {
          this.classifyDatas = res.data.data
          this.loading  = false
        })
      },
      vantabPlay:function (index) {
        this.$router.push({ name: 'MyNews' ,query:{type:index}})
        this.routerPlay(index)
        /*if(index == 0){
          this.$router.push({ name: 'DealNews' ,query:{type:0}})
        }else if(index == 1){
          this.$router.push({ name: 'MessageNews' ,query:{type:1}})
        }else if(index == 2){
          this.$router.push({ name: 'InteractNews' ,query:{type:2}})
        }*/
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        setTimeout(() => {
          this.page++
          var type = this.classifyDatas[this.active].id
          this.$api.post('WebApi/Message/Index/index', {token:isUser,type:type,p:this.page}, res => {
            if(res.data.errCode == '0000'){
              if(res.data.data == ''){
                _this.finished = true;
                _this.loading = false;
              }else {
                $.each(res.data.data,function (index,items) {
                  _this.datas.push(items)
                })
                _this.loading = false;
              }
            }else {
              _this.finished = true;
              _this.loading = false;
            }
          })
        },50)
      },
    },
    mounted () {
      this.getClassify()
    },
  }
</script>

<style lang="less">
  .mynews{
    .van-content{
      padding-top: 46px;
      padding-bottom: 0;
      .van-tabs__wrap{
        position: fixed;
        top: 46px;
      }
    }
    .newslist{
      .newsbox{
        width: 100%;
        background-color: #fff;
        border-radius: 10px;
        padding: 10px 15px;
        .van-icon-arrow{
          position: absolute;
          right: 35px;
          top: 50%;
          margin-top: -10px;
        }
        .van-card{
          background-color: initial;
          padding: 0 35px 0 70px;
          height: 65px;
          margin-top: 0;
          .newsimgbox{
            left: 0;
            width: 60px;
            height: 60px;
          }
          .news-content{
            height: 60px;
          }
        }
        .noimg{
          padding-left: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/mynews/mynews.vue